import type { SVGProps } from 'react';
import * as React from 'react';

const PencilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/pencil">
      <path
        id="Icon"
        d="M15.8892 5.2832L18.0105 3.16188C18.401 2.77136 19.0342 2.77136 19.4247 3.16188L20.8389 4.5761C21.2294 4.96662 21.2294 5.59979 20.8389 5.99031L18.7176 8.11163M15.8892 5.2832L5.28256 15.8898L3.86835 20.1324L8.11099 18.7182L18.7176 8.11163M15.8892 5.2832L18.7176 8.11163"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default PencilIcon;
